module.exports = __webpack_public_path__ + "media/images/Cornerstone-Box-With-Logo-01-980f28f2d6921b2da26f4710a6e74dad.jpg";